<section class="circle-gradient overflow-hidden">
  <div class="breadcrumb-sec event-sec">
    <div class="container">
      <div class="row g-0">
        <div class="col-md-6">
          <ul class="breadcrumb">
            <li><a href="https://raisoni.net/">Home</a></li>
            <li><i class="fa fa-angle-right"></i></li>
            <li><a href="events-new">Events</a></li>
            <li><i class="fa fa-angle-right"></i></li>
            <li><a href="events-new#cultural">Cultural</a></li>
            <li><i class="fa fa-angle-right"></i></li>
            <li>Chatrapati Shivaji Maharaj Jayanti</li>
          </ul>
          <div class="sec-title">
            <h1><span>Chatrapati Shivaji Maharaj Jayanti</span></h1>
            <p>
              G H Raisoni College of Arts, Commerce and Science proudly
              celebrated Chhatrapati Shivaji Maharaj Jayanti, honouring the
              legacy of courage, leadership and visionary governance that
              continues to inspire generations.
            </p>
          </div>
        </div>
        <div class="breadcrumb-overlay overflow-hidden" style="
            background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/shivaji-jaynti-1.webp);
          "></div>
      </div>
    </div>
  </div>
</section>

<div class="section-lg">
  <div class="container">
    <div class="sec-title text-center">
      <h2><span>Photo Gallery</span></h2>
    </div>
    <div class="demo-gallery photo-gallery">
      <ul class="lightgallery">
        <li class="grid-item1"
          data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/shivaji-jaynti-2.webp"
          data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/shivaji-jaynti-2.webp"
          data-sub-html="&lt;p&gt;Dhamaal Dandiya&lt;/p&gt;">
          <a href="#">
            <img loading="lazy" decoding="async" class="img-fluid"
              src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/shivaji-jaynti-2.webp" />
          </a>
        </li>
        <li class="grid-item2"
          data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/shivaji-jaynti-3.webp"
          data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/shivaji-jaynti-3.webp"
          data-sub-html="&lt;p&gt;Dhamaal Dandiya&lt;/p&gt;">
          <a href="#">
            <img loading="lazy" decoding="async" class="img-fluid"
              src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/shivaji-jaynti-3.webp" />
          </a>
        </li>
        <li class="grid-item3 d-none d-lg-block d-md-block"
          data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/shivaji-jaynti-4.webp"
          data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/shivaji-jaynti-4.webp"
          data-sub-html="&lt;p&gt;Dhamaal Dandiya&lt;/p&gt;">
          <a href="#">
            <img loading="lazy" decoding="async" class="img-fluid"
              src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/shivaji-jaynti-4.webp" />
          </a>
        </li>
        <li class="grid-item4"
          data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/shivaji-jaynti-5.webp"
          data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/shivaji-jaynti-5.webp"
          data-sub-html="&lt;p&gt;Dhamaal Dandiya&lt;/p&gt;">
          <a href="#">
            <img loading="lazy" decoding="async" class="img-fluid"
              src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/shivaji-jaynti-5.webp" />
          </a>
        </li>
        <li class="grid-item5"
          data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/shivaji-jaynti-6.webp"
          data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/shivaji-jaynti-6.webp"
          data-sub-html="&lt;p&gt;Dhamaal Dandiya&lt;/p&gt;">
          <a href="#">
            <img loading="lazy" decoding="async" class="img-fluid"
              src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/shivaji-jaynti-6.webp" />
          </a>
        </li>
        <li class="grid-item6 d-none d-lg-block d-md-block"
          data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/shivaji-jaynti-7.webp"
          data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/shivaji-jaynti-7.webp"
          data-sub-html="&lt;p&gt;Dhamaal Dandiya&lt;/p&gt;">
          <a href="#">
            <img loading="lazy" decoding="async" class="img-fluid"
              src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/shivaji-jaynti-7.webp" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
